/**
 * field theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/field.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { fieldAnatomy } from '@chakra-ui/react/anatomy';
export const field = defineSlotRecipe({
    slots: fieldAnatomy.keys(),
    base: {},
    variants: {
        orientation: {
            inset: {
                requiredIndicator: {
                    color: 'currentcolor',
                },
                root: {
                    minH: '64px',
                    flexShrink: 0,
                    flexDir: 'column',
                    gap: '4px',
                    bgColor: 'white',
                    rounded: '8px',
                    borderWidth: '2px',
                    borderColor: 'text.secondary',
                    px: '16px',
                    pt: '8px',
                    pb: '6px',
                    '& .chakra-textarea': {
                        flex: 1,
                    },
                    '& .chakra-input': {
                        my: 'auto',
                    },
                    _focusWithin: {
                        justifyContent: 'flex-start',
                        borderColor: 'text.default',
                        boxShadow: '2px 2px 0px 0px #42213C',
                        _invalid: {
                            boxShadow: '2px 2px 0px 0px {colors.state.error}',
                        },
                        '& .chakra-field__label': {
                            display: 'flex',
                        },
                    },
                    // if field's input has non-empty value
                    "&:has([value]:not([value=''])), &:has(textarea:not(:empty))": {
                        '& .chakra-field__label': {
                            display: 'flex',
                        },
                    },
                    _invalid: {
                        borderColor: 'state.error',
                    },
                    _disabled: {
                        borderColor: 'state.disabled',
                        bgColor: 'state.disabledBg',
                    },
                },
                label: {
                    display: 'none',
                    textStyle: 'caption',
                    gap: '0',
                },
                errorText: {
                    color: 'state.error',
                    textStyle: 'caption',
                    px: '16px',
                },
                helperText: {
                    color: 'text.default',
                    textStyle: 'caption',
                    px: '16px',
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {
        orientation: 'inset',
    },
});
